import * as Namespaces from './namespaces'

const locales = {
	[Namespaces.PROJECTS]: {
		el: {
			'Invalid date': 'Μη έγκυρη ημερομηνία',
			'Required': 'Απαιτείται',
			'With Contribution': 'Με Εισφορά',
			'Actions':'Ενέργειες',
			'Add' : 'Προσθήκη',
			'Edit' : 'Επεξεργασία',
			'Default' : 'Προεπιλογή',
			'An error occurred!' : 'Παρουσιάστηκε σφάλμα!',
			'Description' : 'Περιγραφή',
			'Foreman' : 'Εργοδηγός',
			'Start Date' : 'Ημ/νία Έναρξης',
			'End Date' : 'Ημ/νία Λήξης',
			'Estim. Cost' : 'Προϋπολογισμός',
			'Est. Date' : 'Εκτιμ. Ημ/νία',
			'Active' : 'Ενεργό',
			'Projects' : 'Έργα',
			'Projects List' : 'Λίστα Έργων',
			'The end date must be after the start date.' : 'Η ημερομηνία λήξης πρέπει να είναι μετά την ημερομηνία έναρξης',
			'Details': 'Λεπτομέρειες',
			'Delete' : 'Διαγραφή',
			'Return' : 'Επιστροφή',
			'Save' : 'Αποθήκευση',
			'Project Create' : 'Δημιουργία έργου',
			'Project Edit' : 'Επεξεργασία έργου',
			'Start date must be before the end date.' : 'Η ημερομηνία έναρξης πρέπει να είναι πριν την ημερομηνία λήξης.',
			'Project created successfully!' : 'Το έργο δημιουργήθηκε με επιτυχία!',
			'Project updated successfully!' : 'Το έργο ενημερώθηκε με επιτυχία!',
			'Project Details' : 'Πληροφορίες έργου',
			'All data related to this project will be deleted!' : 'Όλα τα δεδομένα που σχετίζονται με αυτό το έργο θα διαγραφούν!',
			'Project' : 'Έργο',
			'Project deleted successfully!' : 'Το έργο διαγράφηκε με επιτυχία!',
			'EstimCost' : 'Προϋπολογισμός',
			'General' : 'Γενικά',
			'Total Hours & Costs': 'Συνολικές Ώρες & Κόστοι',
			// 'Total Work Time' : 'Κανονικές ώρες',
			// 'Total Work Cost' : 'Κανονικό κόστος',
			// 'Total Extra Work Time' : 'Υπερωριακές ώρες',
			// 'Total Extra Work Cost' : 'Υπερωριακό κόστος',
			'Name' : 'Όνομα',
			'Date' : 'Ημερομηνία',
			'Work Time' : 'Ώρες εργασίας',
			'Extra Work Time' : 'Υπερ. ώρες',
			'Work Cost' : 'Κόστος εργασίας',
			'Extra Work Cost' : 'Υπερ. κόστος',
			'Work Hours of Project' : 'Ώρες εργασίες του έργου',
			'Start' : 'Έναρξη',
			'End' : 'Λήξη',
			'Sum Work' : 'Άθροισμα Εργασίας',
			'Sum Cost' : 'Άθροισμα Κόστους',
			'Remaining' : 'Υπόλοιπο',
			'Registrations of Project' : 'Καταχωρήσεις Έργου',
			'WorkDt' : 'Ημέρα Εργασίας',
			'Total Work Time' : 'Σύνολο ωρών',
			'Total Extra Work Time' : 'Σύνολο υπερωριών',
			'Total Cost' : 'Σύνολο Κόστους',
		},
		en: {
			'WorkDt' : 'Work Date',
		}
	},
}

export default locales